export const typographyScale = {
    TYPE12: '12px',
    TYPE14: '14px',
    TYPE16: '16px',
    TYPE20: '20px',
    TYPE30: '30px'
}